(function () {
  // Jours fériés français pour une année donnée
  function getJoursFeries(year) {
    var a = year % 19, b = Math.floor(year / 100), c = year % 100,
        d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25),
        g = Math.floor((b - f + 1) / 3),
        h = (19 * a + b - d - g + 15) % 30,
        i = Math.floor(c / 4), k = c % 4,
        l = (32 + 2 * e + 2 * i - h - k) % 7,
        m = Math.floor((a + 11 * h + 22 * l) / 451),
        month = Math.floor((h + l - 7 * m + 114) / 31) - 1,
        day = ((h + l - 7 * m + 114) % 31) + 1;

    var easter = new Date(year, month, day);

    function add(date, days) {
      var d = new Date(date);
      d.setDate(d.getDate() + days);
      return d;
    }

    function toKey(d) {
      return d.getFullYear() + '-' +
        String(d.getMonth() + 1).padStart(2, '0') + '-' +
        String(d.getDate()).padStart(2, '0');
    }

    var fixed = [
      year + '-01-01',
      year + '-05-01',
      year + '-05-08',
      year + '-07-14',
      year + '-08-15',
      year + '-11-01',
      year + '-11-11',
      year + '-12-25',
    ];

    var mobile = [
      toKey(add(easter, 1)),
      toKey(add(easter, 39)),
      toKey(add(easter, 49)),
      toKey(add(easter, 50)),
    ];

    return new Set(fixed.concat(mobile));
  }

  function addBusinessDays(startDate, days) {
    var date = new Date(startDate);
    var added = 0;
    var feries = getJoursFeries(date.getFullYear());

    while (added < days) {
      date.setDate(date.getDate() + 1);

      if (date.getMonth() === 0 && date.getDate() === 1) {
        feries = getJoursFeries(date.getFullYear());
      }

      var dow = date.getDay();
      var key = date.getFullYear() + '-' +
        String(date.getMonth() + 1).padStart(2, '0') + '-' +
        String(date.getDate()).padStart(2, '0');

      if (dow !== 0 && dow !== 6 && !feries.has(key)) {
        added++;
      }
    }
    return date;
  }

  function formatDate(date) {
    var mois = [
      'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
      'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'
    ];
    return date.getDate() + ' ' + mois[date.getMonth()];
  }

  function renderDeliveryDates() {
    var el = document.getElementById('delivery-range');
    if (!el) return;

    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var dateMin = addBusinessDays(today, 2);
    var dateMax = addBusinessDays(today, 5);
    el.textContent = 'Entre le ' + formatDate(dateMin) + ' et le ' + formatDate(dateMax);
  }

  document.addEventListener('DOMContentLoaded', renderDeliveryDates);
})();